<template>
	<div id="home" class="mainPage">
		<div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
		  <ol class="carousel-indicators">
		    <li data-target="#carousel-example-generic" data-slide-to="0" class="active" style="margin-right:15px;"></li>
		    <li data-target="#carousel-example-generic" data-slide-to="1" style="margin-right:15px;"></li>
			<!-- <li data-target="#carousel-example-generic" data-slide-to="2"></li> -->
		  </ol>

		  <!-- Wrapper for slides -->
		  <div class="carousel-inner" role="listbox">
			<!-- <div class="item active bannerPage1">
		      <img src="../assets/img/banner_new.jpg" alt="..." >
		      <div class="carousel-caption">
		      	<div class="container">
			        <h1>视频内容分析与处理</h1>
			        <p>高效、批量自动化处理视频水印、片头片尾 、广告</p>
					<p>实现视频处理日完成量1000+通过多维AI技术，对视频进行智能分析</p>
					<p>集关键帧识别、语音识别、视频OCR、泛标签提取等技术一体的智能视频处理</p>
		        </div>
		      </div>
		    </div> -->

		    <div class="item active bannerPage1">
		      <img src="../assets/img/banner1.jpg" alt="...">
		      <div class="carousel-caption">
		      	<div class="container">
			        <h1>深能智见<span>数据治理</span></h1>
			        <h2>您身边的数据自动化服务商</h2>
			        <p>旨在为客户提供智能的数据安全、采集、治理、分析等自动化解决方案</p>
			        <p>智能、高效、深度挖掘数据的价值。</p>
		        </div>
		      </div>
		    </div>
		    <div class="item bannerPage1">
		      <img src="../assets/img/banner2.jpg" alt="...">
		      <div class="carousel-caption">
		      	<div class="container">
		      		<h2>京东数科、天星数科（原小米金融）<br>战略投资企业</h2>
			        <h3>武汉股权托管交易中心挂牌企业</h3>
			        <img src="../assets/img/lg01.png"/>
			        <img src="../assets/img/lg03.png"/>
			        <img src="../assets/img/lg02.png"/>
		      	</div>

		      </div>
		    </div>
		    <!-- <div class="item">
		      <img src="../assets/img/banner1.jpg" alt="...">
		      <div class="carousel-caption">
		        ...
		      </div>
		    </div> -->
		  </div>

		  <!-- Controls -->
		  <!-- <a class="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
		    <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
		    <span class="sr-only">Previous</span>
		  </a>
		  <a class="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
		    <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
		    <span class="sr-only">Next</span>
		  </a> -->
		</div>
		<div class="vedio" id="vedioBox">
			<div class="container vedioBox main">
				<div class="title">
					<h2>我们的服务</h2>
					<p>
						<span>SERVICE</span>
					</p>
				</div>
				<p class="dec">选择深能智见服务，解决数据孤岛难题，显著降本增效。</p>
				<div class="row">
					<div class="col-md-4 col-xs-12" v-for="(item,index) in vedioAr">
						<!-- <div class="box" @click="playVedio(index)" >
							<i class="iconfont typeIcon" :class="item.icon"></i>
							<p class="title">{{item.title}}</p>
							<p class="dec">{{item.dec}}</p>
							<div class="hover">
								<i class="iconfont icon-ziyuan"></i>
							</div>
						</div> -->
						<div class="vedioBoxItem" @click="playVedio(index)" >
							<div class="hover">
								<img :src="require('../assets/img/s'+index+'.png')"/>
								<div class="hoverBox">
									<i class="iconfont icon-ziyuan"></i>
								</div>
							</div>
							<p class="title">{{item.title}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="serve" :style="serveBg">
			<div class="serveBox">
				<div class="container main">
					<!-- <img class="snzj" src="../assets/img/snzj.png"/> -->
					<div class="title">
						<h2>我们的优势</h2>
						<p>
							<span>ADVANTAGE</span>
						</p>
					</div>
					<!-- <p class="dec">深能智见RPA+DPA，科技赋能，数据驱动，推动企业数字化变革。</p> -->
					<div class="row" style="margin-top:30px;">
						<div class="col-md-6">
							<div class="box">
								<p class="icon"><i class="iconfont icon-fuwu"></i></p>
								<span>专业技术团队</span>
								<p>研发团队对RPA+DPA应用和实施有丰富的经验，涵盖OCR、NLP、流程挖掘、数据分析等各类技术专家。</p>
							</div>
						</div>
						<div class="col-md-6">
							<div class="box" >
								<p class="icon"><i class="iconfont icon-crew_tech"></i></p>
								<span>多项技术突破</span>
								<p>OCR、NLP等人工智能能力深度整合，突破传统数据处理多项限制，实现了面向数据准备的全流程RPA模式。</p>
							</div>
						</div>
						<div class="col-md-6">
							<div class="box ">
								<p class="icon"><i class="iconfont icon-anquanzhuye"></i></p>
								<span>数据安全专家</span>
								<p>数据安全是最重视的问题，公司有更专业的数据安全专家为企业提供咨询服务，制定安全解决方案。</p>
							</div>
						</div>
						<div class="col-md-6">
							<div class="box">
								<p class="icon"><i class="iconfont icon-zhuanyexitong"></i></p>
								<span>服务体系完善</span>
								<p>我们拥有完善的服务体系，快速响应各类需求，为企业提供更好的服务。</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="partner container main">
			<div class="title">
				<h2>合作伙伴/客户</h2>
				<p>
					<span>PARTNER</span>
				</p>
			</div>
			<div class="partnerBox">
				<div class="box" v-for="item in ptLogo">
					<div class="boxImg">
						<img :src="require('../assets/img/pt'+item+'.png')"/>
					</div>
				</div>
			</div>
		</div>
		<!-- 视频弹窗 -->
		<el-dialog
		  :title="dialogTitle"
		  :visible.sync="dialogVisible"
		  width="820px"
		  :before-close="handleClose">
		  <div style="padding:0 10px 40px 10px;">
		  	<div v-for="item in vedioAr">
		  		<div  v-if="item.videoSrc == videoSrc">
				  <video
			      :id="'myVideo'+videoSrc"
			      class="video-js"
			      v-if="item.videoSrc == videoSrc"
			      >
			      <source
			          :src="'/media/'+videoSrc+'.mp4'"
			          type="video/mp4"
			      >
			    </video></div>
		    </div>
	    </div>
		</el-dialog>
	</div>
</template>

<script>
export default {
  name:'Home',
  data() {
    return {
      serveBg:{
        backgroundImage:'url(' + require('../assets/img/serveBg.jpg') + ')'
      },
      vedioAr:[
        {
          title:'数据交付',
          dec:'请点击查看视频介绍。',
          icon:'icon-caozuochenggong',
          videoSrc:'v1'
        },
		{
          title:'视频内容分析',
          dec:'请点击查看视频介绍。',
          icon:'icon-jurassic_batch-work',
          videoSrc:'v6'
        },
		{
          title:'数据治理',
          dec:'请点击查看视频介绍。',
          icon:'icon-icon_xinyong_xianxing_jijin-',
          videoSrc:'v3'
        },
        {
          title:'数据采集',
          dec:'请点击查看视频介绍。',
          icon:'icon-shoujilaoshijinkutongji',
          videoSrc:'v2'
        },
        {
          title:'数据安全',
          dec:'请点击查看视频介绍。',
          icon:'icon-anquan',
          videoSrc:'v4'
        },
        {
          title:'数据防泄漏',
          dec:'请点击查看视频介绍。',
          icon:'icon-yinhuanpaichazhili',
          videoSrc:'v5'
        },
      
      ],
      dialogVisible:false,
      dialogTitle:'',
      ptLogo:['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20'],
      videoSrc:'v1'
    }
  },
  mounted() {

  },
  created() {

  },
  methods:{
    initVideo() {
      //初始化视频方法

      let videoDom = document.getElementById('myVideo'+this.videoSrc);
      this.myPlayer = null;
      this.myPlayer = this.$video(videoDom, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: "muted",
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        width: "800px",
        //设置视频播放器的显示高度（以像素为单位）
        height: "400px"
      });
      this.myPlayer.play()
    },
    playVedio(index) {
    	this.dialogVisible = true;
    	this.dialogTitle = this.vedioAr[index].title;
    	this.videoSrc = this.vedioAr[index].videoSrc;
    	this.$nextTick(() => {
        this.initVideo();
      })
    },
    handleClose() {
    	this.myPlayer.pause();
    	this.dialogVisible = false;
    }
  }
}
</script>

<style lang="scss">
.vjs-control-bar{
	margin-bottom: -30px;
	opacity:1!important;
}
#home{
	.vedio{
		position: relative;
		background-color: #fbfbfb;
		.vedioBox{
			// position: absolute;
	  //   top: -40px;
	  //   left: 50%;
	  //   transform: translateX(-50%);
	  h1{
	  	text-align: center;
	  	font-weight: bold;
	  	margin-bottom: 20px;
	  	color: $--bg-primary;
	  }
	  p.dec{
	  	text-align: center;
	  	margin-bottom: 30px;
	  	color: $--bg-primary;
	  	i{
	  		color: $--color-primary;
	  		padding:0 10px;
	  	}
	  }
	    .row{
	    	img{
	    		width: 100%;
	    	}
	    	>div{
	    		&:nth-child(4),&:nth-child(5),&:nth-child(6){
	    			.box{
	    				// background-color: $--color-primary;
	    			}
	    		}
	    	}
	    }
		}
		.box{
			background-color: #fff;
			padding:15px;
			margin-bottom: 30px;
			box-shadow: 0 0 5px #d8dfe3;
			position: relative;
			border-radius: 5px;
			&:hover{
				box-shadow: 0 0 10px #a0c7e0;
				.hover{
					display: block;
				}
			}
			.hover{
				position: absolute;
				top: 0;left: 0;
				width: 100%;
				height: 100%;
				background-color: rgba(153, 199, 229, 0.4);
				border-radius: 5px;
				display: none;
				cursor: pointer;
				i{
					position: absolute;
					top: 50%;
					left: 50%;
					transform:translate(-50%,-50%);
					font-size: 40px;
					color: #fff;
				}
			}
			i.typeIcon{
				font-size: 40px;
				color: $--color-primary;
			}
			.title{
				font-size: 20px;
				color: $--bg-primary;
			}
			.dec{
				font-size: 13px;
				color: #999;
			}
		}
		.vedioBoxItem{
			padding:0;
			background-color: #fff;
			margin-bottom: 30px;
			box-shadow: 0 0 5px #d8dfe3;
			position: relative;
			border-radius: 5px;
			overflow: hidden;
			p{
				padding: 10px;
				margin:0;
				font-weight: bold;
				font-size: 16px;
				color: $--bg-primary;
			}
			.hover{
				position: relative;
				cursor: pointer;
				img{
					width: 100%;
          filter: blur(3px);
				}
				.hoverBox{
					position: absolute;
					top: 0;left: 0;
					width: 100%;height: 100%;
					background-color: rgba(31,31,31,0.4);
					i{
						position: absolute;
						top: 50%;
						left: 50%;
						transform:translate(-50%,-50%);
						font-size: 40px;
						color: rgba(255,255,255,0.7);
						transition:all 0.5s;
						//transform-origin:50% 50%;
					}
				}
				&:hover{
					i{
						color: $--color-primary!important;
						transform:scale(1.1) translate(-50%,-50%);
					}
				}
			}
		}
	}

}
@media (max-width: 768px){
	#home{
		.banner{
			.left{
				padding-top: 0;
				.title{
					font-size: 20px;
				}
				.dec{
					padding:10px 0;
					font-size: 14px;
				}
				.btn{
					padding: 10px 40px;
				}
			}


		}
		.vedio{
			.vedioBox{
				width: 100%;
			}
		}
		.serve{
			.serveBox{
				p{
					span{
						padding:0 15px;
					}
				}
			}
		}
	}
}
</style>
